module.exports = __webpack_public_path__ + "static/img/homeBanner.beb81a90.jpg";